/*
 *   File : radio-group.js
 *   Author URI : https://evoqins.com
 *   Description : Radio button component
 *   Version : v2.0
 */

import React, { useState, useEffect } from "react";
import Icon from "../icons";

function RadioGroup({
  label,
  value,
  labelStyle,
  require,
  className,
  options = [],
  onChange,
  defaultValue = null
}) {
  const [selected, setSelected] = useState(value || defaultValue);

  // Add this useEffect to sync internal state with prop changes
  useEffect(() => {
    if (value !== undefined) {
      setSelected(value);
    }
  }, [value]);

  const handleSelect = (value) => {
    setSelected(value);
    onChange && onChange(value); // send final selected value to parent
  };

  return (
    <div>
      {label && (
        <label
          className={
            labelStyle
              ? labelStyle
              : "fw-400 fs-14 lh-20 text-eerie-black pb-2"
          }
        >
          {label}
          {require && <span className="text-danger">*</span>}
        </label>
      )}

      <div
        className={`${className} d-flex align-items-center gap-4 flex-wrap pb-3`}
      >
        {options.map((item, key) => {
          const isSelected = selected === item.value;

          return (
            <div
              key={key}
              className="d-flex align-items-center e-cursor-pointer"
              onClick={() => handleSelect(item.value)}
            >
              <div className="text-start">
                <Icon icon={isSelected ? "selected" : "unselect"} size={16} />
              </div>

              <span
                className={`fw-400 fs-12 lh-24 text-eerie-black ${
                  isSelected ? "e-text-black" : "e-text-gray-x11"
                } ms-2 cursor-pointer pt-1`}
              >
                {item.label}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default RadioGroup;